import { type MouseEvent } from 'react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, useTooltip } from '@frontend/design-system';

interface ShareInEmailFooterProps {
  onGoBack: () => void;
  onSubmit: (e: MouseEvent<HTMLButtonElement>) => void;
  disabled: boolean;
  backTrackingId: string;
  primaryTrackingId: string;
  showDisabledTooltip?: boolean;
}

export const ShareInEmailFooter = ({
  onGoBack,
  onSubmit,
  disabled,
  backTrackingId,
  primaryTrackingId,
  showDisabledTooltip,
}: ShareInEmailFooterProps) => {
  const { t } = useTranslation('payments-share-in-email');
  const { tooltipProps, triggerProps, Tooltip } = useTooltip();

  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2),
      }}
    >
      <Button variant='tertiary' size='large' onClick={onGoBack} iconName='arrow-left' trackingId={backTrackingId}>
        {t('Back')}
      </Button>
      <Button
        {...(showDisabledTooltip ? triggerProps : {})}
        variant='primary'
        size='large'
        onClick={onSubmit}
        disabled={disabled}
        trackingId={primaryTrackingId}
      >
        {t('Send')}
      </Button>
      {showDisabledTooltip && <Tooltip {...tooltipProps}>{t('Please select at least one recipient.')}</Tooltip>}
    </div>
  );
};
